import React from 'react'
import styles from './Loading.module.scss'

const Loading = ({ size }) => (
  <span className={`${styles.loader} ${styles[size]}`} />
)

export default React.memo(Loading)
